import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Grid,
} from "@material-ui/core";
import React from "react";
import { FormattedMessage } from "react-intl";
import styled from "styled-components";
import FormSection from "../../../ServicePage/components/FormComponents/FormSection";
import cuideoTheme from "../../../../../../containers/themes/defaultTheme";
import { TCrossSellingOption } from "../../models/ServiceFollowUpForm";

const StyledFormControl = styled(FormControl)`
  background-color: #fff;
  padding: 0.5rem 0.75rem;
  border-radius: 0.5rem;
  border: 0.125rem solid #ebc200;
  box-shadow: 0 2px 8px 0 rgba(0, 75, 123, 0.2);

  .MuiFormLabel-root {
    display: block;
    font-size: 1.125rem;
    color: ${cuideoTheme.palette.primary.main};
  }

  .MuiSvgIcon-root {
    width: 1.25rem;
    height: 1.25rem;
  }

  .MuiFormControlLabel-label {
    font-size: 1rem;
  }
`;

interface ISelectionFollowUpForm {
  handFootCareQuestion: TCrossSellingOption;
  onHandFootCareQuestionChange: (newValue: TCrossSellingOption) => void;
  medicCareQuestion: TCrossSellingOption;
  onMedicCareQuestionChange: (newValue: TCrossSellingOption) => void;
  healthyFoodQuestion: TCrossSellingOption;
  onHealthyFoodQuestionChange: (newValue: TCrossSellingOption) => void;
  stimulationQuestion: TCrossSellingOption;
  onStimulationQuestionChange: (newValue: TCrossSellingOption) => void;
}

const SelectionFollowUpForm = (props: ISelectionFollowUpForm) => {
  const {
    handFootCareQuestion,
    onHandFootCareQuestionChange,
    medicCareQuestion,
    onMedicCareQuestionChange,
    healthyFoodQuestion,
    onHealthyFoodQuestionChange,
    stimulationQuestion,
    onStimulationQuestionChange,
  } = props;

  return (
    <FormSection>
      <Grid container spacing={8}>
        <Grid item xs={12} md={6}>
          <StyledFormControl variant="standard">
            <FormLabel component="legend">
              <FormattedMessage
                id="SelectionFollowUp.¿Le gustaría algunos consejos sobre cuidado de pies y manos de los mayores?"
                defaultMessage="¿Le gustaría algunos consejos sobre cuidado de pies y manos de los mayores?"
              />
            </FormLabel>
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={handFootCareQuestion === "Si"}
                    onChange={() => {
                      onHandFootCareQuestionChange("Si");
                    }}
                    color="primary"
                  />
                }
                label={
                  <FormattedMessage
                    id="SelectionFollowUp.Si"
                    defaultMessage="Si"
                  />
                }
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={handFootCareQuestion === "No"}
                    onChange={() => {
                      onHandFootCareQuestionChange("No");
                    }}
                    color="primary"
                  />
                }
                label={
                  <FormattedMessage
                    id="SelectionFollowUp.No"
                    defaultMessage="No"
                  />
                }
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={handFootCareQuestion === "Mas adelante"}
                    onChange={() => {
                      onHandFootCareQuestionChange("Mas adelante");
                    }}
                    color="primary"
                  />
                }
                label={
                  <FormattedMessage
                    id="SelectionFollowUp.Más adelante"
                    defaultMessage="Más adelante"
                  />
                }
              />
            </FormGroup>
          </StyledFormControl>
        </Grid>
        <Grid item xs={12} md={6}>
          <StyledFormControl variant="standard">
            <FormLabel component="legend">
              <FormattedMessage
                id="SelectionFollowUp.¿Le gustaría conocer algunos consejos médicos sobre el cuidado de los mayores?"
                defaultMessage="¿Le gustaría conocer algunos consejos médicos sobre el cuidado de los mayores?"
              />
            </FormLabel>
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={medicCareQuestion === "Si"}
                    onChange={() => {
                      onMedicCareQuestionChange("Si");
                    }}
                    color="primary"
                  />
                }
                label={
                  <FormattedMessage
                    id="SelectionFollowUp.Si"
                    defaultMessage="Si"
                  />
                }
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={medicCareQuestion === "No"}
                    onChange={() => {
                      onMedicCareQuestionChange("No");
                    }}
                    color="primary"
                  />
                }
                label={
                  <FormattedMessage
                    id="SelectionFollowUp.No"
                    defaultMessage="No"
                  />
                }
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={medicCareQuestion === "Mas adelante"}
                    onChange={() => {
                      onMedicCareQuestionChange("Mas adelante");
                    }}
                    color="primary"
                  />
                }
                label={
                  <FormattedMessage
                    id="SelectionFollowUp.Más adelante"
                    defaultMessage="Más adelante"
                  />
                }
              />
            </FormGroup>
          </StyledFormControl>
        </Grid>
        <Grid item xs={12} md={6}>
          <StyledFormControl variant="standard">
            <FormLabel component="legend">
              <FormattedMessage
                id="SelectionFollowUp.¿Le gustaría algunos consejos sobre comida saludable adaptada a su ser querido?"
                defaultMessage="¿Le gustaría algunos consejos sobre comida saludable adaptada a su ser querido?"
              />
            </FormLabel>
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={healthyFoodQuestion === "Si"}
                    onChange={() => {
                      onHealthyFoodQuestionChange("Si");
                    }}
                    color="primary"
                  />
                }
                label={
                  <FormattedMessage
                    id="SelectionFollowUp.Si"
                    defaultMessage="Si"
                  />
                }
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={healthyFoodQuestion === "No"}
                    onChange={() => {
                      onHealthyFoodQuestionChange("No");
                    }}
                    color="primary"
                  />
                }
                label={
                  <FormattedMessage
                    id="SelectionFollowUp.No"
                    defaultMessage="No"
                  />
                }
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={healthyFoodQuestion === "Mas adelante"}
                    onChange={() => {
                      onHealthyFoodQuestionChange("Mas adelante");
                    }}
                    color="primary"
                  />
                }
                label={
                  <FormattedMessage
                    id="SelectionFollowUp.Más adelante"
                    defaultMessage="Más adelante"
                  />
                }
              />
            </FormGroup>
          </StyledFormControl>
        </Grid>
        <Grid item xs={12} md={6}>
          <StyledFormControl variant="standard">
            <FormLabel component="legend">
              <FormattedMessage
                id="SelectionFollowUp.¿Quiere consejos sobre cómo estimular física y cognitivamente al usuario?"
                defaultMessage="¿Quiere consejos sobre cómo estimular física y cognitivamente al usuario?"
              />
            </FormLabel>
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={stimulationQuestion === "Si"}
                    onChange={() => onStimulationQuestionChange("Si")}
                    color="primary"
                  />
                }
                label={
                  <FormattedMessage
                    id="SelectionFollowUp.Si"
                    defaultMessage="Si"
                  />
                }
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={stimulationQuestion === "No"}
                    onChange={() => onStimulationQuestionChange("No")}
                    color="primary"
                  />
                }
                label={
                  <FormattedMessage
                    id="SelectionFollowUp.No"
                    defaultMessage="No"
                  />
                }
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={stimulationQuestion === "Mas adelante"}
                    onChange={() => onStimulationQuestionChange("Mas adelante")}
                    color="primary"
                  />
                }
                label={
                  <FormattedMessage
                    id="SelectionFollowUp.Más adelante"
                    defaultMessage="Más adelante"
                  />
                }
              />
            </FormGroup>
          </StyledFormControl>
        </Grid>
      </Grid>
    </FormSection>
  );
};

export default SelectionFollowUpForm;
